import React from 'react';
import KickImage from 'Reuseables/KickImage';
import {
  Pagination, PaginationItem, PaginationLink
} from 'reactstrap'

// Calculate page count
const pageCount = (props) => {
  // console.log('pageCount', props);
	return parseInt((props.total/props.perPage)+(props.total%props.perPage>0?1:0));
}

	// Calculate median from maxPage state
const median = (props) => {
  // console.log('median', props);
	return parseInt(props.maxPage/2)-(props.maxPage%2>1?0:1);
}

  // Calculate start page items to show
const startIndex = (props) => {
  // console.log('startIndex', props);
	let startIndex=1;
	if(pageCount(props)<props.maxPage){
    startIndex=1;
  } else if(parseInt(props.currentPage/props.maxPage)>0){
		if((props.currentPage-median(props)+props.maxPage)<=pageCount(props)){
      // console.log('1');
      startIndex=props.currentPage-median(props);
    } else {
      // console.log('2');
      startIndex=pageCount(props)-props.maxPage+1;
    }
	} else if(props.currentPage%props.maxPage>props.maxPage-2){
    // console.log('3', median(props));
    startIndex=props.currentPage-median(props) + 1;
  }

	return startIndex;
}

	// Calculate end page items to show
const endIndex = (props) => {
	let endIndex=0;
	let startIn=startIndex(props);
	if(pageCount(props)==props.currentPage){
    endIndex=pageCount(props);
  } else if(startIn+(props.maxPage-1)<=pageCount(props)){
    endIndex=startIn+(props.maxPage-1);
  }	else {
    return pageCount(props);
  }

	return endIndex;
}

// Generate first page links
const firstPage = (props) => {
	if(startIndex(props)>median(props)){
		let items=[
			<PaginationItem>
			  <PaginationLink onClick={(e)=>props.handleGoto(e, 1)}>
			  1
				</PaginationLink>
			</PaginationItem>,
			<PaginationItem>
			  <PaginationLink onClick={(e)=>props.handleGoto(e, 2)}>
			  2
				</PaginationLink>
			</PaginationItem>,
			<PaginationItem  disabled>
			  <PaginationLink >
			  ...
				</PaginationLink>
			</PaginationItem>
		];
		return items;
	}
	return ''
}

// Generate last page links
const	lastPage = (props) => {
	if((endIndex(props)+2) < pageCount(props)){
		let items=[
			<PaginationItem  disabled>
			  <PaginationLink >
			  ...
				</PaginationLink>
			</PaginationItem>,
			<PaginationItem>
			  <PaginationLink onClick={(e)=>props.handleGoto(e, pageCount(props)-1)}>
			  {pageCount(props)-1}
				</PaginationLink>
			</PaginationItem>,
			<PaginationItem>
			  <PaginationLink onClick={(e)=>props.handleGoto(e, pageCount(props))}>
			  {pageCount(props)}
				</PaginationLink>
			</PaginationItem>
		];
		return items;
	}
	return ''
}

  // Loop items using startIndex and endIndex
const medianPage = (props) => {
 	let items=[];
 	// console.log('start',startIndex(props))
 	// console.log('end',endIndex(props))
 	for (let i = startIndex(props); i <= endIndex(props); i++) {
 		let item=(
 					<PaginationItem
 						active={i==props.currentPage}
 						key={i}
 					>
						  <PaginationLink
                onClick={(e)=>props.handleGoto(e, i)}
                >
						    {i}
						  </PaginationLink>
						</PaginationItem>
				)
 		items.push(item);
 	}
 	return items;
}

const Paginations = (props) => {
  return(
    <Pagination>
      <PaginationItem disabled={props.currentPage === 1}>
        <PaginationLink onClick={(e)=>props.handleGoto(e, props.currentPage - 1)}>
          {'<'}
        </PaginationLink>
      </PaginationItem>
      {firstPage(props)}
      {medianPage(props)}
      {lastPage(props)}
      <PaginationItem disabled={props.currentPage === props.lastPage}>
        <PaginationLink onClick={(e)=>props.handleGoto(e, props.currentPage + 1)}>
          {`>`}
        </PaginationLink>
      </PaginationItem>
    </Pagination>
  )
}

Paginations.defaultProps = {
  total: 4,
  currentPage: 1,
  maxPage: 18,
  onClick: () => {}
}

export default Paginations
